
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.44 13.44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M.006 12.023L12.026.003l1.415 1.414-12.02 12.02z"}}),_c('path',{attrs:{"fill":"#fff","d":"M.006 1.417L1.42.002l12.021 12.021-1.414 1.415z"}})])
          )
        }
      }
    